<section role="region" class="wrapper--bg container">
  <div class="content">
    <img
      class="content__img"
      [src]="imgSrc | imaginarySrc: 1:222"
      [srcset]="imgSrc | imaginarySrc: 4:222"
      alt="Logo du Contrat d'Engagement Jeune"
    />
    <p class="content__text">
      L&apos;appli qui vous permet d&apos;échanger plus facilement avec votre conseiller et de réaliser vos recherches
      d&apos;emploi, d&apos;immersion, d&apos;alternance et de service civique.
    </p>
    <ul class="content__actions">
      <li>
        <a
          class="btn-clean"
          href="https://play.google.com/store/apps/details?id=fr.fabrique.social.gouv.passemploi&gl=FR"
          target="_blank"
          (click)="trackEvent({ category: 'CEJ', action: 'Click Google Store', type: 'navigation' })"
          aria-label="Télécharger l'application Contrat Engagement Jeune sur Google Play"
          ignoreExternLink
        >
          <img
            class="content__badge"
            [src]="googlePlayBadgeSrc | imaginarySrc: 1:180"
            [srcset]="googlePlayBadgeSrc | imaginarySrc: 4:180"
            alt="Badge Google Play"
          />
        </a>
      </li>
      <li>
        <a
          class="btn-clean"
          href="https://apps.apple.com/fr/app/contrat-dengagement-jeune/id1581603519"
          target="_blank"
          (click)="trackEvent({ category: 'CEJ', action: 'Click Apple Store', type: 'navigation' })"
          aria-label="Télécharger l'application sur Contrat Engagement Jeune sur Apple Store"
          ignoreExternLink
        >
          <img
            class="content__badge"
            [src]="appStoreBadgeSrc | imaginarySrc: 1:180"
            [srcset]="appStoreBadgeSrc | imaginarySrc: 4:180"
            alt="Badge Apple Store"
          />
        </a>
      </li>
    </ul>
  </div>
</section>
